import { render } from "./NumberInput.vue?vue&type=template&id=c193de04&lang=pug"
import script from "./NumberInput.vue?vue&type=script&lang=ts"
export * from "./NumberInput.vue?vue&type=script&lang=ts"
script.render = render

export default script